import React from "react";
import { FiX } from "react-icons/fi";
import styled from "styled-components";
import Button from "../../../components/Button";
import ModalPopUp from "../../../components/ModalPopUp";
import { Body, Title2 } from "../../../styles/typography";

const ModalWrapper = styled.div`
  max-width: 500px;
  padding: 24px;
  background-color: white;
  height: auto;
  border-radius: 8px;
`;
const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  > svg {
    position: absolute;
    right: -10px;
    top: -10px;
    cursor: pointer;
  }
`;
const StyledTitle = styled(Title2)`
  padding: 16px 0px 16px 32px;
`;
const Content = styled(Body)`
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 16px;
  color: rgb(${(props) => props.theme.colors.neutral200});
`;
const ButtonWrapper = styled.div`
  display: flex;
  padding: 0px 32px 16px 32px;
  gap: 12px;
  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`;
const StyledButton = styled(Button)`
  width: 120px;
  @media screen and (max-width: 800px) {
    width: 100%;
  }
`;
const DeletePopUp = (props) => {
  return (
    <ModalPopUp isOpen={props.open} onRequestClose={props.close}>
      <ModalWrapper>
        <TitleWrapper>
          <StyledTitle>Are you sure?</StyledTitle>
          <FiX onClick={() => props.close()} />
        </TitleWrapper>
        <Content>Image will be deleted from this memory.</Content>
        <ButtonWrapper>
          <StyledButton variant="secondary" onButtonClick={() => props.close()}>
            Cancel
          </StyledButton>
          <StyledButton variant="warning" onButtonClick={props.onDeleteImage}>
            Delete
          </StyledButton>
        </ButtonWrapper>
      </ModalWrapper>
    </ModalPopUp>
  );
};
export default DeletePopUp;
